// 导入所有API文件（包括子目录）
const files = require.context('./api', true, /\.js$/)

// 辅助函数：根据路径数组创建嵌套对象
function setNestedProperty(obj, pathArray, value) {
  let current = obj;
  // 遍历路径数组（除最后一项外，创建中间对象）
  for (let i = 0; i < pathArray.length - 1; i++) {
    const key = pathArray[i];
    // 如果当前层级不存在，初始化空对象
    if (!current[key]) {
      current[key] = {};
    }
    // 进入下一层级
    current = current[key];
  }
  // 最后一项作为属性名，赋值为模块导出
  const lastKey = pathArray[pathArray.length - 1];
  current[lastKey] = value;
}

// 解析文件路径，生成嵌套结构
function importAll(r) {
  const lib = {};
  r.keys().forEach(key => {
    // 1. 处理路径：去除开头的'./'和结尾的'.js'，例如 './user/list.js' → 'user/list'
    const cleanPath = key.replace(/^\.\/|\.js$/g, '');
    // 2. 按'/'分割路径为数组，得到层级 ['user', 'list']
    const pathArray = cleanPath.split('/');
    // 3. 获取模块默认导出
    const module = r(key).default;
    if (module) {
      // 4. 用模块的name属性或路径最后一段作为最终属性名
      const finalKey = module.name || pathArray[pathArray.length - 1];
      // 替换数组最后一项为最终属性名（处理name自定义的情况）
      pathArray[pathArray.length - 1] = finalKey;
      // 5. 创建嵌套对象并赋值
      setNestedProperty(lib, pathArray, module);
    }
  });
  return lib;
}

export default importAll(files);



// WEBPACK FOOTER //
// ./src/request/index.js